<template>
	<div :class="classNames+ '_text'" v-html="data.text">
	</div>
</template>
<script>
	export default {
		props: {
			data: {
				type: Object,
				default: () => ({
				})
			},
		},
		data() {
			return {
				classNames: 'messageItem',
			}
		},
		methods: {
			
		}
	}
</script>
<style src="./chat-message.less" lang="less" scoped>
</style>
